import { Component, Input, OnInit } from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';

@Component({
  selector: 'app-dashboard-remaining-invitations-card',
  templateUrl: './dashboard-remaining-invitations-card.component.html',
  styleUrls: ['./dashboard-remaining-invitations-card.component.scss'],
})
export class DashboardRemainingInvitationsCardComponent implements OnInit {
  @Input() recurrentRevenue: any;
  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;
  readonly MAX_DEFAULT_INVITE = 250;

  ngOnInit(): void {
    if (window.__dev__) console.log("'Method not implemented.'");
  }
}
